<template>
  <div class="app" id="app">
    <ToggleMap v-if="showIndicesNavigation" :show="!this.$store.state.selections.covid19"></ToggleMap>
    <main class="l-mainwrap">
      <PageSidebarNavigation v-if="showIndicesNavigation" class="l-mainwrap__sidebar"></PageSidebarNavigation>

      <div :class="{
        'l-mainwrap__main': showIndicesNavigation,
        'l-mainwrap__main-full': !showIndicesNavigation
      }">
        <level-navigation v-if="showIndicesNavigation" :rout="$store.state.covid19.is_enabled" class="l-mainwrap__main__navigation"></level-navigation>

        <!-- <helptoolbar></helptoolbar> -->
        <ViewSelector v-if="showIndicesNavigation" class="level-navigation__selector"></ViewSelector>
        <CovidToolbar v-if="$store.state.covid19.is_enabled"></CovidToolbar>
        <tutorials></tutorials>

        <router-view></router-view>
      </div>
      <!-- /.l-mainwrap__main -->
    </main>
    <!-- /.l-mainwrap -->

    <tooltip></tooltip>
    <popup></popup>

    <theFooter></theFooter>

    <!-- <tour></tour> -->
  </div>
</template>


<script>
import 'es6-promise/auto'

import axios from 'axios'
import _ from 'lodash'

import ToggleMap from './components/shared/misc/ToggleMap'
import PageSidebarNavigation from './components/shared/navigation/PageSidebarNavigation/Nav'
import LevelNavigation from './components/shared/navigation/LevelNavigation'
import helptoolbar from './components/shared/misc/HelpToolbar.vue'
import CovidToolbar from './components/shared/misc/CovidToolbar.vue'
import tutorials from './components/tutorials/Tutorials.vue'
import tooltip from './components/shared/misc/MouseTooltip.vue'
import popup from './components/shared/misc/Popup.vue'
import ViewSelector from './components/shared/misc/ViewSelector'
// import tour from './components/tour/layout.vue'

import theFooter from './components/shared/footer/layout.vue'

import {EventBus} from '@/event-bus.js'
import Vue from 'vue'

export default {
  name: 'app',
  components: {
    CovidToolbar,
    helptoolbar,
    LevelNavigation,
    PageSidebarNavigation,
    popup,
    theFooter,
    tooltip,
    ViewSelector,
    ToggleMap,
    // tour,
    tutorials
  },
  data () {
    return {
      showIndicesNavigation: true
    }
  },
  metaInfo () {
    return {
      title: 'The Global State of Democracy initiative',
      meta: [
        { name: 'description', content: 'The Global State of Democracy Indices (GSoD Indices) depict democratic trends at the country, regional and global levels across a broad range of different attributes of democracy in the period 1975–2021.' },
        { property: 'og:title', content: 'The Global State of Democracy initiative' },
        { property: 'og:site_name', content: 'The Global State of Democracy initiative' },
        { property: 'og:type', content: 'website' },
        { name: 'robots', content: 'index,follow' }
      ]
    }
  },
  computed: {
    covid19FeatureIsonline () {
      return this.$Strings('covid19_feature_enabled') === 'online' || process.env.NODE_ENV === 'development'
    },
    covid19IsEnabled () {
      return this.$store.state.covid19.is_enabled
    },
    vw () {
      return this.$store.state.windowSize.width
    },
    vh () {
      return this.$store.state.windowSize.height
    },
    selectedAttributes () {
      return this.$store.state.attributes.selected
    },
    selectedRscs () {
      return this.$store.state.rsc.selected
    },
    confidenceInterval () {
      return this.$store.state.confidenceIntervals
    },
    viewmode () {
      return this.$store.state.viewMode
    }
  },
  watch: {
    '$store.state.covid19.is_enabled' () {
      if (this.$store.state.covid19.is_enabled) {
        this.$store.state.yearSliderCurrent = 2021
      }
      this.$store.state.selections.covid19 = this.$store.state.covid19.is_enabled
    },
    '$route' () {
      this.updateShowIndicesNavigation()
      this.updateUserSelection()
      this.clearCovid19OnlyRsc()
      this.getApiData()
    },
    vw () {
      this.setContentSize()
    },
    vh () {
      this.setContentSize()
    },
    selectedAttributes () {
      this.$store.state.selections.attr = this.selectedAttributes
    },
    selectedRscs () {
      let rscs = []
      _.each(this.selectedRscs, (c) => {
        rscs.push(c.id)
      })
      this.$store.state.selections.rsc = rscs
    },
    confidenceInterval () {
      this.$store.state.selections.ci = this.confidenceInterval
    },
    viewmode () {
      this.$store.state.selections.view = this.viewmode
    }
  },
  methods: {
    clearCovid19OnlyRsc () {
      let rscCovidOnly = this.$store.state.selections.rsc
      for (let i = 0; i < rscCovidOnly.length; i++) {
        const rscId = rscCovidOnly[i]
        if (this.$store.state.rsc.rscCovidProfileOnly.indexOf(parseInt(rscId)) !== -1) {
          let selected = this.$store.getters['rsc/getFromId'](rscId)
          this.$store.commit('rsc/unselect', selected)
        }
      }
    },
    filterCountries (d) {
      for (let r in d.regions) {
        d.regions[r].name = Vue.filter('fixedName')(d.regions[r].name)
        for (let s in d.regions[r].subregions) {
          d.regions[r].subregions[s].name = Vue.filter('fixedName')(d.regions[r].subregions[s].name)
          for (let c in d.regions[r].subregions[s].countries) {
            d.regions[r].subregions[s].countries[c].name = Vue.filter('fixedName')(d.regions[r].subregions[s].countries[c].name)
            if (d.regions[r].name === d.regions[r].subregions[s].name && d.regions[r].subregions[s].name === d.regions[r].subregions[s].countries[c].name) {
              delete (d.regions[r].subregions[s].countries[c])
            }
          }
        }
      }
      return d
    },
    getApiData () {
      if (this.$router.history.current.path.indexOf('/welcome') === -1) {
        this.$store.dispatch('startFetching', 'app')

        axios.all([this.loadCovid19Data(), this.loadCountries(), this.loadLabels()])
        .then(axios.spread((covid19, countries, labels) => {
          this.$store.state.covid19.all = covid19.data
          this.$store.state.rsc.all = this.filterCountries(countries.data)
          this.$store.state.attributes.labels = labels.data
          this.$store.dispatch('stopFetching', 'app')

          this.updateUserSelection()
        }))
        .catch((error) => {
          EventBus.$emit('popup.open', this.$Strings('json_error_title'), this.$Strings('json_error_body'))
          console.log(error)
        })
      }
    },
    windowResize () {
      this.getWindowSize()
      EventBus.$emit('window:resize')
    },

    /**
      * Checks the query strings first to see if
      * there is a selection
      * Then afterwards check for precious user selections
      * @param  {string} key The key of the value to look for
      * @return {mixed}
      */
    getUserSelectionValue (key) {
      let selection = this.$store.state.selections[key]

      if (this.$router.history.current &&
              this.$router.history.current.query &&
              this.$router.history.current.query[key] !== undefined) {
        return JSON.parse(this.$router.history.current.query[key])
      } else if (selection && (!Array.isArray(selection) || (selection.length >= 1))) {
        return selection
      }

      return undefined
    },

    /**
      * Update selections based on values from the URL
      * @return {void}
      */
    updateUserSelection () {
      let rsc = this.getUserSelectionValue('rsc')
      let attr = this.getUserSelectionValue('attr')
      let ci = this.getUserSelectionValue('ci')
      let view = this.getUserSelectionValue('view')
      let covid19 = this.getUserSelectionValue('covid19')

      this.$store.commit('resetSelectionColor')
      this.$store.commit('rsc/resetAllSelected')
      this.$store.commit('attributes/resetAllSelected')

      if (rsc) {
        _.each(rsc, (id) => {
          let selected = this.$store.getters['rsc/getFromId'](id)
          if (selected) {
            this.$store.commit('rsc/select', selected)
          }
        })
      }

      if (attr) {
        if (attr.length >= 1) {
          this.$store.state.regime_enabled = false
        }
        _.each(attr, (key) => {
          let selected = this.$store.getters['attributes/getLabelFromKey'](key)
          if (selected) {
            this.$store.dispatch('attributes/toggleSelect', key)
          }
        })
      }

      let ciValue = true
      if (ci !== undefined && (ci === 'false' || ci === false)) {
        ciValue = false
      }
      this.$store.state.confidenceIntervals = ciValue
      this.$store.state.viewMode = (view === 'table') ? 'table' : 'chart'

      if (covid19 && covid19 === '1' && this.covid19FeatureIsonline) {
        this.$store.state.covid19.is_enabled = true
      } else if (covid19 === '0' || !this.covid19FeatureIsonline) {
        this.$store.state.covid19.is_enabled = false
      }
    },

    updateShowIndicesNavigation () {
      this.showIndicesNavigation = this.notFound ? false : (this.$router.history.current.path.indexOf('/welcome') === -1)
      // this.showIndicesNavigation = (this.$router.history.current.path.substring(0, 8) === '/indices' && this.$router.history.current.path.indexOf('/welcome') === -1)
    },

    getWindowSize () {
      this.$store.state.windowSize.width = document.documentElement.clientWidth
      this.$store.state.windowSize.height = document.documentElement.clientHeight
    },

    getMousePosition (event) {
      EventBus.$emit('mousemove')
      let xOffset = Math.max(document.documentElement.scrollLeft, document.body.scrollLeft)
      let yOffset = Math.max(document.documentElement.scrollTop, document.body.scrollTop)
      this.$store.state.mousePosition = {
        x: (event.clientX + xOffset),
        y: (event.clientY + yOffset)
      }
    },

    setAppHeight () {
      // let app = document.getElementById('app')
      // app.style.minHeight = (this.$store.state.windowSize.height - 50) + 'px' // 50 is the main nav bar
    },

    setContentSize () {
      let header = document.getElementsByClassName('l-header')[0]
      let headerHeight = (header && header.clientHeight) ? header.clientHeight : 0

      let mainNav = document.getElementsByClassName('l-mainwrap__main__navigation')[0]
      let mainNavHeight = (mainNav && mainNav.clientHeight) ? mainNav.clientHeight : 0

      let side = document.getElementsByClassName('l-mainwrap__sidebar')[0]
      let sideWidth = (side && side.clientWidth) ? side.clientWidth : 0

      let vw = this.vw
      let vh = this.vh

      this.$store.state.contentSize = { 'width': (vw - sideWidth), 'height': (vh - headerHeight - mainNavHeight) }
    },
    loadCovid19Data () {
      return axios.get(process.env.COVID19_API_URL + 'covid19/countries?t=' + this.apiRefreshToken())
    },
    loadCountries () {
      return axios.get(process.env.API_URL + 'countries')
    },
    loadLabels () {
      return axios.get(process.env.API_URL + 'labels')
    }
  },
  destroyed () {
    window.removeEventListener('resize', this.windowResize)
    document.removeEventListener('mousemove', this.getMousePosition, false)
    document.removeEventListener('mouseenter', this.getMousePosition, false)
  },
  created () {
    document.addEventListener('mousemove', this.getMousePosition, false)
    document.addEventListener('mouseenter', this.getMousePosition, false)
    this.getApiData()
  },
  mounted () {
    this.updateShowIndicesNavigation()
    this.$nextTick(() => {
      window.addEventListener('resize', this.windowResize)
      this.setContentSize()
      this.getWindowSize()
      this.setAppHeight()
    })
  }
}
</script>

<style lang="scss">
@import '~@/components/sass/shared/colors';
@import '~@/components/sass/shared/fonts';
@import '~@/components/sass/shared/helpers';
@import '~@/components/sass/shared/animations';
@import '~@/components/sass/shared/typography';
@import '~@/components/sass/components/profiletable';

html {
  box-sizing: border-box;
  font-size: $font-size;
}
*, *:before, *:after {
  box-sizing: inherit;
}

HTML, BODY{
  color: $gray-darkest;
  margin: 0;
  min-height: 100%;
  height: 100%;
  padding: 0;
}

BODY{
  font-family: $fontfamily-sans-serif;
  font-size: $font-size;
  line-height: $line-height;
  min-width: 960px;
}

H1, H2, H3, H4{
  color: $gray-darkest;
  font-family: $fontfamily-serif;
  font-weight: 500;
  line-height: 1.2;
  margin: 50px 0 20px;
}

H1{ font-size: 35px; }

H1.page-title{
  margin-bottom: 0;
  margin-top: 0;
}

A:link,
A:visited,
A{ color: $purple-light }

A:active,
A:focus,
A:hover{ color: darken($purple-light, 5%) }

.main-wrap{
  margin: 60px 0;
  padding-left: 40px;
  padding-right: 40px;
  position: relative;
  max-width: 960px;
  min-width: 710px;
}

.main-wrap.full-width {
  max-width: 100%;
}

.l-wrap{
  display: flex; -js-display: flex;
  flex-direction: column;
  min-height: 100%;
  min-width: 960px;

  &> *{
    flex: 0 0 auto;
  }
}

.l-header{
  background: $gray-darkest;
  font-weight: 500;
  flex: 0 0 auto;
  width: 100%;

  &__newsletter {
    background: $blue-300;
    color: $blue-200;
    display: block;
    font-size: 13px;
    padding-bottom: 0.25rem;
    padding-right: 4%;
    padding-top: 0.25rem;
    text-align: right;
    width: 100%;

    a {
      text-decoration: none;
      color: $blue-200;
      display: inline-block;
      padding: .25rem 20px;
      transition: all .25 ease;

      &:hover {
        color: $white;
        text-decoration: nonw;
      }
    }
  }
}

.l-header__navigation{
  display: block;
  float: right;
  padding: 0 25px;
}

.l-header__brand{
  display: block;
  float: left;
  font-weight: bold;
  text-align: center;
  width: 285px;
  &.isFront{
    width: 430px;
  }
  A{
    color: $white;
    display: block;
    text-decoration: none;
    padding-bottom: 17px;
    padding-top: 17px;
  }
  &.isFront A{
    border-bottom: 2px solid $white;
    padding-bottom: calc(13px - 2px);
    padding-top: 13px;
    font-size:21px;
  }
}

//.l-header__navigation{ padding-right: 4%; }
.l-header__navigation{ padding-right: 0; }

.l-mainwrap{
  flex: 1 1 100%;
  display: flex; -js-display: flex;
  min-height: 100%;
}

.l-mainwrap__sidebar{
  background: $gray-lightest;
  box-shadow: 2px 2px 15px 0 transparentize($gray-darkest, 0.85);
  flex: 0 0 250px;
  font-size: 14px;
  position: relative;
  width: 250px;
  z-index: 300;
}

.l-mainwrap__main-full{
  width:100%;
}
.l-mainwrap__main{
  flex: 1 1 100%;
  position: relative;
  max-width: calc(100% - 250px); //substract the sidebar width
}

.app{
  min-height: 100%;
}

/**
  * Page navigation
  */
.page-navigation{}
.nav{}

.nav__navigation{
  text-align: right;
  list-style-type: none;
  margin: 0 0 -2px;
  padding: 0;
}

.nav__navigation LI{
  display: inline-block;

  A{
    color: $white;
    display: inline-block;
    padding: 19px 20px;
    text-decoration: none;

    @media(max-width: 1100px) {
      padding-left: 10px;
      padding-right: 10px;
    }

    &:hover{ background: $gray-black; }
  }
  &.active A{
    border-bottom: 2px solid $white;
    padding-bottom: calc(1em - 2px);
  }
}

/**
  * Text page content wrapper
  */
.main-content{
  margin: 0 auto;
  max-width: 600px;
}

/**
  * The media object
  */
.media {
  display: flex; -js-display: flex;
  align-items: flex-start;
  padding-bottom: 1em;
  padding-top: 1em;
}
.media-figure { margin-right: 1em; }
.media-body { flex: 1; }

/**
  * Styling for the node page
  */

.page-node-type-page{
  margin-bottom: 100px;

  // Simple table styling
  table {
    border: none;
    border: 1px solid $blue-dark;
    border-collapse: collapse;

    td, th {
      border: none;
      border: 1px solid $blue-dark;
      padding: .25rem;
      font-size: 0.86rem;
    }

    tr:nth-child(odd) {
      background: $blue-100;
    }
  }

}



</style>



// WEBPACK FOOTER //
// src/App.vue